import { render, staticRenderFns } from "./MeetBlockBen.vue?vue&type=template&id=37046b13&scoped=true"
import script from "./MeetBlockBen.vue?vue&type=script&lang=js"
export * from "./MeetBlockBen.vue?vue&type=script&lang=js"
import style0 from "./MeetBlockBen.vue?vue&type=style&index=0&id=37046b13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37046b13",
  null
  
)

export default component.exports